import React from "react"
import PropTypes from "prop-types"
import Footer from "../Footer"
import GlobalStyles from "../../styles/global"
import ZapDown from "../../components/ZapDown"
import NavBar from "../../components/NavBar"
import { Container } from "./styled.js"
import "./styles.css"

const Layout = ({ children }) => {
  return (
    <>
      <Container>
        <GlobalStyles />
        <NavBar />
        <main>{children}</main>
        <ZapDown />
      </Container>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
